import { api } from "./client";

export type ScorecardPromo = {
  origin_event_id: string | null;
  origin_name: string;
  origin_slug: string | null;
  event_name: string;
  is_general_default: boolean;
  is_house_default_now: boolean;
  is_unattributed: boolean;
  house_default_start_at: string | null;
  house_default_end_at: string | null;
  signups: number;
  verifications: number;
};

export type ScorecardNextPromo = {
  origin_event_id: string;
  origin_name: string;
  event_name: string;
  house_default_start_at: string;
};

export type Scorecard = {
  window: { start: string; end: string };
  totals: {
    signups: number;
    creator_verifications: number;
    work_certifications: number;
  };
  promos: ScorecardPromo[];
  next_promo: ScorecardNextPromo | null;
};

export const ScorecardApi = {
  get() {
    return api.get<Scorecard>("/scorecard").then((r) => r.data);
  },
};
